<script lang="ts">
  import { mapDigitalSourceTypeToImageTypeDescription } from "utils/fns";
  import VisibleForEndUsers from "./VisibleForEndUsers.svelte";
  import { calculateCreditLine, type Image } from "bildebanken-model";

  export let image: Partial<Image>;

  $: creditLine = calculateCreditLine(image.metadata || undefined);

  $: imageTypeLabel = mapDigitalSourceTypeToImageTypeDescription(image.metadata?.digitalSourceType);
</script>

<div class="credit-row">
  <VisibleForEndUsers />
  <span style="margin-left: var(--org-xsmall)">
    <em>{imageTypeLabel}</em>
    <em data-testid="calculated-credit-line">{creditLine || "Ukjent"}</em>
  </span>
</div>

<style>
  .credit-row {
    font-size: 12px;
    display: flex;
    background-color: var(--color-surface-tertiary);
    padding-top: var(--org-xsmall);
    padding-bottom: var(--org-xsmall);
    padding-right: var(--org-small);
    width: fit-content;
    border-radius: var(--org-xsmall);
    color: var(--color-text-primary);
  }
</style>
